// Unicode text transformers for Text.onl

export interface UnicodeMapping {
  [key: string]: string;
}

// Basic alphabets for mathematical styles
const mathBold: UnicodeMapping = {
  A: "𝐀",
  B: "𝐁",
  C: "𝐂",
  D: "𝐃",
  E: "𝐄",
  F: "𝐅",
  G: "𝐆",
  H: "𝐇",
  I: "𝐈",
  J: "𝐉",
  K: "𝐊",
  L: "𝐋",
  M: "𝐌",
  N: "𝐍",
  O: "𝐎",
  P: "𝐏",
  Q: "𝐐",
  R: "𝐑",
  S: "𝐒",
  T: "𝐓",
  U: "𝐔",
  V: "𝐕",
  W: "𝐖",
  X: "𝐗",
  Y: "𝐘",
  Z: "𝐙",
  a: "𝐚",
  b: "𝐛",
  c: "𝐜",
  d: "𝐝",
  e: "𝐞",
  f: "𝐟",
  g: "𝐠",
  h: "𝐡",
  i: "𝐢",
  j: "𝐣",
  k: "𝐤",
  l: "𝐥",
  m: "𝐦",
  n: "𝐧",
  o: "𝐨",
  p: "𝐩",
  q: "𝐪",
  r: "𝐫",
  s: "𝐬",
  t: "𝐭",
  u: "𝐮",
  v: "𝐯",
  w: "𝐰",
  x: "𝐱",
  y: "𝐲",
  z: "𝐳",
};

const mathItalic: UnicodeMapping = {
  A: "𝐴",
  B: "𝐵",
  C: "𝐶",
  D: "𝐷",
  E: "𝐸",
  F: "𝐹",
  G: "𝐺",
  H: "𝐻",
  I: "𝐼",
  J: "𝐽",
  K: "𝐾",
  L: "𝐿",
  M: "𝑀",
  N: "𝑁",
  O: "𝑂",
  P: "𝑃",
  Q: "𝑄",
  R: "𝑅",
  S: "𝑆",
  T: "𝑇",
  U: "𝑈",
  V: "𝑉",
  W: "𝑊",
  X: "𝑋",
  Y: "𝑌",
  Z: "𝑍",
  a: "𝑎",
  b: "𝑏",
  c: "𝑐",
  d: "𝑑",
  e: "𝑒",
  f: "𝑓",
  g: "𝑔",
  h: "ℎ",
  i: "𝑖",
  j: "𝑗",
  k: "𝑘",
  l: "𝑙",
  m: "𝑚",
  n: "𝑛",
  o: "𝑜",
  p: "𝑝",
  q: "𝑞",
  r: "𝑟",
  s: "𝑠",
  t: "𝑡",
  u: "𝑢",
  v: "𝑣",
  w: "𝑤",
  x: "𝑥",
  y: "𝑦",
  z: "𝑧",
};

const mathBoldItalic: UnicodeMapping = {
  A: "𝑨",
  B: "𝑩",
  C: "𝑪",
  D: "𝑫",
  E: "𝑬",
  F: "𝑭",
  G: "𝑮",
  H: "𝑯",
  I: "𝑰",
  J: "𝑱",
  K: "𝑲",
  L: "𝑳",
  M: "𝑴",
  N: "𝑵",
  O: "𝑶",
  P: "𝑷",
  Q: "𝑸",
  R: "𝑹",
  S: "𝑺",
  T: "𝑻",
  U: "𝑼",
  V: "𝑽",
  W: "𝑾",
  X: "𝑿",
  Y: "𝒀",
  Z: "𝒁",
  a: "𝒂",
  b: "𝒃",
  c: "𝒄",
  d: "𝒅",
  e: "𝒆",
  f: "𝒇",
  g: "𝒈",
  h: "𝒉",
  i: "𝒊",
  j: "𝒋",
  k: "𝒌",
  l: "𝒍",
  m: "𝒎",
  n: "𝒏",
  o: "𝒐",
  p: "𝒑",
  q: "𝒒",
  r: "𝒓",
  s: "𝒔",
  t: "𝒕",
  u: "𝒖",
  v: "𝒗",
  w: "𝒘",
  x: "𝒙",
  y: "𝒚",
  z: "𝒛",
};

const mathSans: UnicodeMapping = {
  A: "𝖠",
  B: "𝖡",
  C: "𝖢",
  D: "𝖣",
  E: "𝖤",
  F: "𝖥",
  G: "𝖦",
  H: "𝖧",
  I: "𝖨",
  J: "𝖩",
  K: "𝖪",
  L: "𝖫",
  M: "𝖬",
  N: "𝖭",
  O: "𝖮",
  P: "𝖯",
  Q: "𝖰",
  R: "𝖱",
  S: "𝖲",
  T: "𝖳",
  U: "𝖴",
  V: "𝖵",
  W: "𝖶",
  X: "𝖷",
  Y: "𝖸",
  Z: "𝖹",
  a: "𝖺",
  b: "𝖻",
  c: "𝖼",
  d: "𝖽",
  e: "𝖾",
  f: "𝖿",
  g: "𝗀",
  h: "𝗁",
  i: "𝗂",
  j: "𝗃",
  k: "𝗄",
  l: "𝗅",
  m: "𝗆",
  n: "𝗇",
  o: "𝗈",
  p: "𝗉",
  q: "𝗊",
  r: "𝗋",
  s: "𝗌",
  t: "𝗍",
  u: "𝗎",
  v: "𝗏",
  w: "𝗐",
  x: "𝗑",
  y: "𝗒",
  z: "𝗓",
};

const mathMonospace: UnicodeMapping = {
  A: "𝙰",
  B: "𝙱",
  C: "𝙲",
  D: "𝙳",
  E: "𝙴",
  F: "𝙵",
  G: "𝙶",
  H: "𝙷",
  I: "𝙸",
  J: "𝙹",
  K: "𝙺",
  L: "𝙻",
  M: "𝙼",
  N: "𝙽",
  O: "𝙾",
  P: "𝙿",
  Q: "𝚀",
  R: "𝚁",
  S: "𝚂",
  T: "𝚃",
  U: "𝚄",
  V: "𝚅",
  W: "𝚆",
  X: "𝚇",
  Y: "𝚈",
  Z: "𝚉",
  a: "𝚊",
  b: "𝚋",
  c: "𝚌",
  d: "𝚍",
  e: "𝚎",
  f: "𝚏",
  g: "𝚐",
  h: "𝚑",
  i: "𝚒",
  j: "𝚓",
  k: "𝚔",
  l: "𝚕",
  m: "𝚖",
  n: "𝚗",
  o: "𝚘",
  p: "𝚙",
  q: "𝚚",
  r: "𝚛",
  s: "𝚜",
  t: "𝚝",
  u: "𝚞",
  v: "𝚟",
  w: "𝚠",
  x: "𝚡",
  y: "𝚢",
  z: "𝚣",
  "0": "𝟶",
  "1": "𝟷",
  "2": "𝟸",
  "3": "𝟹",
  "4": "𝟺",
  "5": "𝟻",
  "6": "𝟼",
  "7": "𝟽",
  "8": "𝟾",
  "9": "𝟿",
};

const fraktur: UnicodeMapping = {
  A: "𝔄",
  B: "𝔅",
  C: "ℭ",
  D: "𝔇",
  E: "𝔈",
  F: "𝔉",
  G: "𝔊",
  H: "ℌ",
  I: "ℑ",
  J: "𝔍",
  K: "𝔎",
  L: "𝔏",
  M: "𝔐",
  N: "𝔑",
  O: "𝔒",
  P: "𝔓",
  Q: "𝔔",
  R: "ℜ",
  S: "𝔖",
  T: "𝔗",
  U: "𝔘",
  V: "𝔙",
  W: "𝔚",
  X: "𝔛",
  Y: "𝔜",
  Z: "ℨ",
  a: "𝔞",
  b: "𝔟",
  c: "𝔠",
  d: "𝔡",
  e: "𝔢",
  f: "𝔣",
  g: "𝔤",
  h: "𝔥",
  i: "𝔦",
  j: "𝔧",
  k: "𝔨",
  l: "𝔩",
  m: "𝔪",
  n: "𝔫",
  o: "𝔬",
  p: "𝔭",
  q: "𝔮",
  r: "𝔯",
  s: "𝔰",
  t: "𝔱",
  u: "𝔲",
  v: "𝔳",
  w: "𝔴",
  x: "𝔵",
  y: "𝔶",
  z: "𝔷",
};

const boldFraktur: UnicodeMapping = {
  A: "𝕬",
  B: "𝕭",
  C: "𝕮",
  D: "𝕯",
  E: "𝕰",
  F: "𝕱",
  G: "𝕲",
  H: "𝕳",
  I: "𝕴",
  J: "𝕵",
  K: "𝕶",
  L: "𝕷",
  M: "𝕸",
  N: "𝕹",
  O: "𝕺",
  P: "𝕻",
  Q: "𝕼",
  R: "𝕽",
  S: "𝕾",
  T: "𝕿",
  U: "𝖀",
  V: "𝖁",
  W: "𝖂",
  X: "𝖃",
  Y: "𝖄",
  Z: "𝖅",
  a: "𝖆",
  b: "𝖇",
  c: "𝖈",
  d: "𝖉",
  e: "𝖊",
  f: "𝖋",
  g: "𝖌",
  h: "𝖍",
  i: "𝖎",
  j: "𝖏",
  k: "𝖐",
  l: "𝖑",
  m: "𝖒",
  n: "𝖓",
  o: "𝖔",
  p: "𝖕",
  q: "𝖖",
  r: "𝖗",
  s: "𝖘",
  t: "𝖙",
  u: "𝖚",
  v: "𝖛",
  w: "𝖜",
  x: "𝖝",
  y: "𝖞",
  z: "𝖟",
};

const script: UnicodeMapping = {
  A: "𝒜",
  B: "ℬ",
  C: "𝒞",
  D: "𝒟",
  E: "ℰ",
  F: "ℱ",
  G: "𝒢",
  H: "ℋ",
  I: "ℐ",
  J: "𝒥",
  K: "𝒦",
  L: "ℒ",
  M: "ℳ",
  N: "𝒩",
  O: "𝒪",
  P: "𝒫",
  Q: "𝒬",
  R: "ℛ",
  S: "𝒮",
  T: "𝒯",
  U: "𝒰",
  V: "𝒱",
  W: "𝒲",
  X: "𝒳",
  Y: "𝒴",
  Z: "𝒵",
  a: "𝒶",
  b: "𝒷",
  c: "𝒸",
  d: "𝒹",
  e: "ℯ",
  f: "𝒻",
  g: "ℊ",
  h: "𝒽",
  i: "𝒾",
  j: "𝒿",
  k: "𝓀",
  l: "𝓁",
  m: "𝓂",
  n: "𝓃",
  o: "ℴ",
  p: "𝓅",
  q: "𝓆",
  r: "𝓇",
  s: "𝓈",
  t: "𝓉",
  u: "𝓊",
  v: "𝓋",
  w: "𝓌",
  x: "𝓍",
  y: "𝓎",
  z: "𝓏",
};

const boldScript: UnicodeMapping = {
  A: "𝓐",
  B: "𝓑",
  C: "𝓒",
  D: "𝓓",
  E: "𝓔",
  F: "𝓕",
  G: "𝓖",
  H: "𝓗",
  I: "𝓘",
  J: "𝓙",
  K: "𝓚",
  L: "𝓛",
  M: "𝓜",
  N: "𝓝",
  O: "𝓞",
  P: "𝓟",
  Q: "𝓠",
  R: "𝓡",
  S: "𝓢",
  T: "𝓣",
  U: "𝓤",
  V: "𝓥",
  W: "𝓦",
  X: "𝓧",
  Y: "𝓨",
  Z: "𝓩",
  a: "𝓪",
  b: "𝓫",
  c: "𝓬",
  d: "𝓭",
  e: "𝓮",
  f: "𝓯",
  g: "𝓰",
  h: "𝓱",
  i: "𝓲",
  j: "𝓳",
  k: "𝓴",
  l: "𝓵",
  m: "𝓶",
  n: "𝓷",
  o: "𝓸",
  p: "𝓹",
  q: "𝓺",
  r: "𝓻",
  s: "𝓼",
  t: "𝓽",
  u: "𝓾",
  v: "𝓿",
  w: "𝔀",
  x: "𝔁",
  y: "𝔂",
  z: "𝔃",
};

// Additional Unicode mappings for extended styles
const doubleStruck: UnicodeMapping = {
  A: "𝔸",
  B: "𝔹",
  C: "ℂ",
  D: "𝔻",
  E: "𝔼",
  F: "𝔽",
  G: "𝔾",
  H: "ℍ",
  I: "𝕀",
  J: "𝕁",
  K: "𝕂",
  L: "𝕃",
  M: "𝕄",
  N: "ℕ",
  O: "𝕆",
  P: "ℙ",
  Q: "ℚ",
  R: "ℝ",
  S: "𝕊",
  T: "𝕋",
  U: "𝕌",
  V: "𝕍",
  W: "𝕎",
  X: "𝕏",
  Y: "𝕐",
  Z: "ℤ",
  a: "𝕒",
  b: "𝕓",
  c: "𝕔",
  d: "𝕕",
  e: "𝕖",
  f: "𝕗",
  g: "𝕘",
  h: "𝕙",
  i: "𝕚",
  j: "𝕛",
  k: "𝕜",
  l: "𝕝",
  m: "𝕞",
  n: "𝕟",
  o: "𝕠",
  p: "𝕡",
  q: "𝕢",
  r: "𝕣",
  s: "𝕤",
  t: "𝕥",
  u: "𝕦",
  v: "𝕧",
  w: "𝕨",
  x: "𝕩",
  y: "𝕪",
  z: "𝕫",
  "0": "𝟘",
  "1": "𝟙",
  "2": "𝟚",
  "3": "𝟛",
  "4": "𝟜",
  "5": "𝟝",
  "6": "𝟞",
  "7": "𝟟",
  "8": "𝟠",
  "9": "𝟡",
};

// Squared = Hollow/outlined squares (U+1F130-U+1F149)
const squared: UnicodeMapping = {
  A: "🄰",
  B: "🄱",
  C: "🄲",
  D: "🄳",
  E: "🄴",
  F: "🄵",
  G: "🄶",
  H: "🄷",
  I: "🄸",
  J: "🄹",
  K: "🄺",
  L: "🄻",
  M: "🄼",
  N: "🄽",
  O: "🄾",
  P: "🄿",
  Q: "🅀",
  R: "🅁",
  S: "🅂",
  T: "🅃",
  U: "🅄",
  V: "🅅",
  W: "🅆",
  X: "🅇",
  Y: "🅈",
  Z: "🅉",
};

// Circled = Hollow circles (U+24B6-U+24E9)
const circled: UnicodeMapping = {
  A: "Ⓐ",
  B: "Ⓑ",
  C: "Ⓒ",
  D: "Ⓓ",
  E: "Ⓔ",
  F: "Ⓕ",
  G: "Ⓖ",
  H: "Ⓗ",
  I: "Ⓘ",
  J: "Ⓙ",
  K: "Ⓚ",
  L: "Ⓛ",
  M: "Ⓜ",
  N: "Ⓝ",
  O: "Ⓞ",
  P: "Ⓟ",
  Q: "Ⓠ",
  R: "Ⓡ",
  S: "Ⓢ",
  T: "Ⓣ",
  U: "Ⓤ",
  V: "Ⓥ",
  W: "Ⓦ",
  X: "Ⓧ",
  Y: "Ⓨ",
  Z: "Ⓩ",
  a: "ⓐ",
  b: "ⓑ",
  c: "ⓒ",
  d: "ⓓ",
  e: "ⓔ",
  f: "ⓕ",
  g: "ⓖ",
  h: "ⓗ",
  i: "ⓘ",
  j: "ⓙ",
  k: "ⓚ",
  l: "ⓛ",
  m: "ⓜ",
  n: "ⓝ",
  o: "ⓞ",
  p: "ⓟ",
  q: "ⓠ",
  r: "ⓡ",
  s: "ⓢ",
  t: "ⓣ",
  u: "ⓤ",
  v: "ⓥ",
  w: "ⓦ",
  x: "ⓧ",
  y: "ⓨ",
  z: "ⓩ",
  "0": "⓪",
  "1": "①",
  "2": "②",
  "3": "③",
  "4": "④",
  "5": "⑤",
  "6": "⑥",
  "7": "⑦",
  "8": "⑧",
  "9": "⑨",
};

// Bubble / Negative Circled = Filled circles (U+1F150-U+1F169)
const bubble: UnicodeMapping = {
  A: "🅐",
  B: "🅑",
  C: "🅒",
  D: "🅓",
  E: "🅔",
  F: "🅕",
  G: "🅖",
  H: "🅗",
  I: "🅘",
  J: "🅙",
  K: "🅚",
  L: "🅛",
  M: "🅜",
  N: "🅝",
  O: "🅞",
  P: "🅟",
  Q: "🅠",
  R: "🅡",
  S: "🅢",
  T: "🅣",
  U: "🅤",
  V: "🅥",
  W: "🅦",
  X: "🅧",
  Y: "🅨",
  Z: "🅩",
};

// Black Squares / Negative Squared = Filled squares (U+1F170-U+1F189)
const blackSquares: UnicodeMapping = {
  A: "🅰",
  B: "🅱",
  C: "🅲",
  D: "🅳",
  E: "🅴",
  F: "🅵",
  G: "🅶",
  H: "🅷",
  I: "🅸",
  J: "🅹",
  K: "🅺",
  L: "🅻",
  M: "🅼",
  N: "🅽",
  O: "🅾",
  P: "🅿",
  Q: "🆀",
  R: "🆁",
  S: "🆂",
  T: "🆃",
  U: "🆄",
  V: "🆅",
  W: "🆆",
  X: "🆇",
  Y: "🆈",
  Z: "🆉",
};

// Outline = Same as squared (hollow squares) for backward compatibility
const outline: UnicodeMapping = {
  A: "🄰",
  B: "🄱",
  C: "🄲",
  D: "🄳",
  E: "🄴",
  F: "🄵",
  G: "🄶",
  H: "🄷",
  I: "🄸",
  J: "🄹",
  K: "🄺",
  L: "🄻",
  M: "🄼",
  N: "🄽",
  O: "🄾",
  P: "🄿",
  Q: "🅀",
  R: "🅁",
  S: "🅂",
  T: "🅃",
  U: "🅄",
  V: "🅅",
  W: "🅆",
  X: "🅇",
  Y: "🅈",
  Z: "🅉",
};

const superscript: UnicodeMapping = {
  A: "ᴬ",
  B: "ᴮ",
  C: "ᶜ",
  D: "ᴰ",
  E: "ᴱ",
  F: "ᶠ",
  G: "ᴳ",
  H: "ᴴ",
  I: "ᴵ",
  J: "ᴶ",
  K: "ᴷ",
  L: "ᴸ",
  M: "ᴹ",
  N: "ᴺ",
  O: "ᴼ",
  P: "ᴾ",
  Q: "Q",
  R: "ᴿ",
  S: "ˢ",
  T: "ᵀ",
  U: "ᵁ",
  V: "ⱽ",
  W: "ᵂ",
  X: "ˣ",
  Y: "ʸ",
  Z: "ᶻ",
  a: "ᵃ",
  b: "ᵇ",
  c: "ᶜ",
  d: "ᵈ",
  e: "ᵉ",
  f: "ᶠ",
  g: "ᵍ",
  h: "ʰ",
  i: "ⁱ",
  j: "ʲ",
  k: "ᵏ",
  l: "ˡ",
  m: "ᵐ",
  n: "ⁿ",
  o: "ᵒ",
  p: "ᵖ",
  q: "q",
  r: "ʳ",
  s: "ˢ",
  t: "ᵗ",
  u: "ᵘ",
  v: "ᵛ",
  w: "ʷ",
  x: "ˣ",
  y: "ʸ",
  z: "ᶻ",
  "0": "⁰",
  "1": "¹",
  "2": "²",
  "3": "³",
  "4": "⁴",
  "5": "⁵",
  "6": "⁶",
  "7": "⁷",
  "8": "⁸",
  "9": "⁹",
};

const subscript: UnicodeMapping = {
  a: "ₐ",
  e: "ₑ",
  h: "ₕ",
  i: "ᵢ",
  j: "ⱼ",
  k: "ₖ",
  l: "ₗ",
  m: "ₘ",
  n: "ₙ",
  o: "ₒ",
  p: "ₚ",
  r: "ᵣ",
  s: "ₛ",
  t: "ₜ",
  u: "ᵤ",
  v: "ᵥ",
  x: "ₓ",
  "0": "₀",
  "1": "₁",
  "2": "₂",
  "3": "₃",
  "4": "₄",
  "5": "₅",
  "6": "₆",
  "7": "₇",
  "8": "₈",
  "9": "₉",
};

const smallCaps: UnicodeMapping = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
  K: "K",
  L: "L",
  M: "M",
  N: "N",
  O: "O",
  P: "P",
  Q: "Q",
  R: "R",
  S: "S",
  T: "T",
  U: "U",
  V: "V",
  W: "W",
  X: "X",
  Y: "Y",
  Z: "Z",
  a: "ᴀ",
  b: "ʙ",
  c: "ᴄ",
  d: "ᴅ",
  e: "ᴇ",
  f: "ғ",
  g: "ɢ",
  h: "ʜ",
  i: "ɪ",
  j: "ᴊ",
  k: "ᴋ",
  l: "ʟ",
  m: "ᴍ",
  n: "ɴ",
  o: "ᴏ",
  p: "ᴘ",
  q: "ǫ",
  r: "ʀ",
  s: "s",
  t: "ᴛ",
  u: "ᴜ",
  v: "ᴠ",
  w: "ᴡ",
  x: "x",
  y: "ʏ",
  z: "ᴢ",
};

const tiny: UnicodeMapping = {
  A: "ᴬ",
  B: "ᴮ",
  C: "ᶜ",
  D: "ᴰ",
  E: "ᴱ",
  F: "ᶠ",
  G: "ᴳ",
  H: "ᴴ",
  I: "ᴵ",
  J: "ᴶ",
  K: "ᴷ",
  L: "ᴸ",
  M: "ᴹ",
  N: "ᴺ",
  O: "ᴼ",
  P: "ᴾ",
  Q: "Q",
  R: "ᴿ",
  S: "ˢ",
  T: "ᵀ",
  U: "ᵁ",
  V: "ⱽ",
  W: "ᵂ",
  X: "ˣ",
  Y: "ʸ",
  Z: "ᶻ",
  a: "ᵃ",
  b: "ᵇ",
  c: "ᶜ",
  d: "ᵈ",
  e: "ᵉ",
  f: "ᶠ",
  g: "ᵍ",
  h: "ʰ",
  i: "ⁱ",
  j: "ʲ",
  k: "ᵏ",
  l: "ˡ",
  m: "ᵐ",
  n: "ⁿ",
  o: "ᵒ",
  p: "ᵖ",
  q: "q",
  r: "ʳ",
  s: "ˢ",
  t: "ᵗ",
  u: "ᵘ",
  v: "ᵛ",
  w: "ʷ",
  x: "ˣ",
  y: "ʸ",
  z: "ᶻ",
  ".": "·",
};

// Additional math styles
const mathSansBold: UnicodeMapping = {
  A: "𝗔",
  B: "𝗕",
  C: "𝗖",
  D: "𝗗",
  E: "𝗘",
  F: "𝗙",
  G: "𝗚",
  H: "𝗛",
  I: "𝗜",
  J: "𝗝",
  K: "𝗞",
  L: "𝗟",
  M: "𝗠",
  N: "𝗡",
  O: "𝗢",
  P: "𝗣",
  Q: "𝗤",
  R: "𝗥",
  S: "𝗦",
  T: "𝗧",
  U: "𝗨",
  V: "𝗩",
  W: "𝗪",
  X: "𝗫",
  Y: "𝗬",
  Z: "𝗭",
  a: "𝗮",
  b: "𝗯",
  c: "𝗰",
  d: "𝗱",
  e: "𝗲",
  f: "𝗳",
  g: "𝗴",
  h: "𝗵",
  i: "𝗶",
  j: "𝗷",
  k: "𝗸",
  l: "𝗹",
  m: "𝗺",
  n: "𝗻",
  o: "𝗼",
  p: "𝗽",
  q: "𝗾",
  r: "𝗿",
  s: "𝘀",
  t: "𝘁",
  u: "𝘂",
  v: "𝘃",
  w: "𝘄",
  x: "𝘅",
  y: "𝘆",
  z: "𝘇",
};

const mathSansItalic: UnicodeMapping = {
  A: "𝘈",
  B: "𝘉",
  C: "𝘊",
  D: "𝘋",
  E: "𝘌",
  F: "𝘍",
  G: "𝘎",
  H: "𝘏",
  I: "𝘐",
  J: "𝘑",
  K: "𝘒",
  L: "𝘓",
  M: "𝘔",
  N: "𝘕",
  O: "𝘖",
  P: "𝘗",
  Q: "𝘘",
  R: "𝘙",
  S: "𝘚",
  T: "𝘛",
  U: "𝘜",
  V: "𝘝",
  W: "𝘞",
  X: "𝘟",
  Y: "𝘠",
  Z: "𝘡",
  a: "𝘢",
  b: "𝘣",
  c: "𝘤",
  d: "𝘥",
  e: "𝘦",
  f: "𝘧",
  g: "𝘨",
  h: "𝘩",
  i: "𝘪",
  j: "𝘫",
  k: "𝘬",
  l: "𝘭",
  m: "𝘮",
  n: "𝘯",
  o: "𝘰",
  p: "𝘱",
  q: "𝘲",
  r: "𝘳",
  s: "𝘴",
  t: "𝘵",
  u: "𝘶",
  v: "𝘷",
  w: "𝘸",
  x: "𝘹",
  y: "𝘺",
  z: "𝘻",
};

const mathSansBoldItalic: UnicodeMapping = {
  A: "𝙰",
  B: "𝙱",
  C: "𝙲",
  D: "𝙳",
  E: "𝙴",
  F: "𝙵",
  G: "𝙶",
  H: "𝙷",
  I: "𝙸",
  J: "𝙹",
  K: "𝙺",
  L: "𝙻",
  M: "𝙼",
  N: "𝙽",
  O: "𝙾",
  P: "𝙿",
  Q: "𝚀",
  R: "𝚁",
  S: "𝚂",
  T: "𝚃",
  U: "𝚄",
  V: "𝚅",
  W: "𝚆",
  X: "𝚇",
  Y: "𝚈",
  Z: "𝚉",
  a: "𝚊",
  b: "𝚋",
  c: "𝚌",
  d: "𝚍",
  e: "𝚎",
  f: "𝚏",
  g: "𝚐",
  h: "𝚑",
  i: "𝚒",
  j: "𝚓",
  k: "𝚔",
  l: "𝚕",
  m: "𝚖",
  n: "𝚗",
  o: "𝚘",
  p: "𝚙",
  q: "𝚚",
  r: "𝚛",
  s: "𝚜",
  t: "𝚝",
  u: "𝚞",
  v: "𝚟",
  w: "𝚠",
  x: "𝚡",
  y: "𝚢",
  z: "𝚣",
};

const regionalIndicator: UnicodeMapping = {
  A: "🇦",
  B: "🇧",
  C: "🇨",
  D: "🇩",
  E: "🇪",
  F: "🇫",
  G: "🇬",
  H: "🇭",
  I: "🇮",
  J: "🇯",
  K: "🇰",
  L: "🇱",
  M: "🇲",
  N: "🇳",
  O: "🇴",
  P: "🇵",
  Q: "🇶",
  R: "🇷",
  S: "🇸",
  T: "🇹",
  U: "🇺",
  V: "🇻",
  W: "🇼",
  X: "🇽",
  Y: "🇾",
  Z: "🇿",
};

const parenthesized: UnicodeMapping = {
  A: "⒜",
  B: "⒝",
  C: "⒞",
  D: "⒟",
  E: "⒠",
  F: "⒡",
  G: "⒢",
  H: "⒣",
  I: "⒤",
  J: "⒥",
  K: "⒦",
  L: "⒧",
  M: "⒨",
  N: "⒩",
  O: "⒪",
  P: "⒫",
  Q: "⒬",
  R: "⒭",
  S: "⒮",
  T: "⒯",
  U: "⒰",
  V: "⒱",
  W: "⒲",
  X: "⒳",
  Y: "⒴",
  Z: "⒵",
  a: "⒜",
  b: "⒝",
  c: "⒞",
  d: "⒟",
  e: "⒠",
  f: "⒡",
  g: "⒢",
  h: "⒣",
  i: "⒤",
  j: "⒥",
  k: "⒦",
  l: "⒧",
  m: "⒨",
  n: "⒩",
  o: "⒪",
  p: "⒫",
  q: "⒬",
  r: "⒭",
  s: "⒮",
  t: "⒯",
  u: "⒰",
  v: "⒱",
  w: "⒲",
  x: "⒳",
  y: "⒴",
  z: "⒵",
};

const fullwidth: UnicodeMapping = {
  A: "Ａ",
  B: "Ｂ",
  C: "Ｃ",
  D: "Ｄ",
  E: "Ｅ",
  F: "Ｆ",
  G: "Ｇ",
  H: "Ｈ",
  I: "Ｉ",
  J: "Ｊ",
  K: "Ｋ",
  L: "Ｌ",
  M: "Ｍ",
  N: "Ｎ",
  O: "Ｏ",
  P: "Ｐ",
  Q: "Ｑ",
  R: "Ｒ",
  S: "Ｓ",
  T: "Ｔ",
  U: "Ｕ",
  V: "Ｖ",
  W: "Ｗ",
  X: "Ｘ",
  Y: "Ｙ",
  Z: "Ｚ",
  a: "ａ",
  b: "ｂ",
  c: "ｃ",
  d: "ｄ",
  e: "ｅ",
  f: "ｆ",
  g: "ｇ",
  h: "ｈ",
  i: "ｉ",
  j: "ｊ",
  k: "ｋ",
  l: "ｌ",
  m: "ｍ",
  n: "ｎ",
  o: "ｏ",
  p: "ｐ",
  q: "ｑ",
  r: "ｒ",
  s: "ｓ",
  t: "ｔ",
  u: "ｕ",
  v: "ｖ",
  w: "ｗ",
  x: "ｘ",
  y: "ｙ",
  z: "ｚ",
  "0": "０",
  "1": "１",
  "2": "２",
  "3": "３",
  "4": "４",
  "5": "５",
  "6": "６",
  "7": "７",
  "8": "８",
  "9": "９",
  ".": "．",
};

const braille: UnicodeMapping = {
  A: "⠁",
  B: "⠃",
  C: "⠉",
  D: "⠙",
  E: "⠑",
  F: "⠋",
  G: "⠛",
  H: "⠓",
  I: "⠊",
  J: "⠚",
  K: "⠅",
  L: "⠇",
  M: "⠍",
  N: "⠝",
  O: "⠕",
  P: "⠏",
  Q: "⠟",
  R: "⠗",
  S: "⠎",
  T: "⠞",
  U: "⠥",
  V: "⠧",
  W: "⠺",
  X: "⠭",
  Y: "⠽",
  Z: "⠵",
  a: "⠁",
  b: "⠃",
  c: "⠉",
  d: "⠙",
  e: "⠑",
  f: "⠋",
  g: "⠛",
  h: "⠓",
  i: "⠊",
  j: "⠚",
  k: "⠅",
  l: "⠇",
  m: "⠍",
  n: "⠝",
  o: "⠕",
  p: "⠏",
  q: "⠟",
  r: "⠗",
  s: "⠎",
  t: "⠞",
  u: "⠥",
  v: "⠧",
  w: "⠺",
  x: "⠭",
  y: "⠽",
  z: "⠵",
  ".": "⠲",
};

// Emoji styles
const emojiLetters: UnicodeMapping = {
  A: "🅰️",
  B: "🅱️",
  C: "🇨",
  D: "🇩",
  E: "🇪",
  F: "🇫",
  G: "🇬",
  H: "🇭",
  I: "🇮",
  J: "🇯",
  K: "🇰",
  L: "🇱",
  M: "🇲",
  N: "🇳",
  O: "🅾️",
  P: "🅿️",
  Q: "🇶",
  R: "🇷",
  S: "🇸",
  T: "🇹",
  U: "🇺",
  V: "🇻",
  W: "🇼",
  X: "🇽",
  Y: "🇾",
  Z: "🇿",
};

const emojiNumbers: UnicodeMapping = {
  "0": "0️⃣",
  "1": "1️⃣",
  "2": "2️⃣",
  "3": "3️⃣",
  "4": "4️⃣",
  "5": "5️⃣",
  "6": "6️⃣",
  "7": "7️⃣",
  "8": "8️⃣",
  "9": "9️⃣",
};

// Arabic-inspired styles
const arabicStyle: UnicodeMapping = {
  A: "ﺍ",
  B: "ﺏ",
  C: "ﺝ",
  D: "ﺩ",
  E: "ﻩ",
  F: "ﻑ",
  G: "ﻍ",
  H: "ﻫ",
  I: "ﻱ",
  J: "ﺝ",
  K: "ﻙ",
  L: "ﻝ",
  M: "ﻡ",
  N: "ﻥ",
  O: "ﻭ",
  P: "ﺏ",
  Q: "ﻕ",
  R: "ﺭ",
  S: "ﺱ",
  T: "ﺕ",
  U: "ﻭ",
  V: "ﻑ",
  W: "ﻭ",
  X: "ﺥ",
  Y: "ﻱ",
  Z: "ﺯ",
};

// Japanese Hiragana style
const hiraganaStyle: UnicodeMapping = {
  A: "あ",
  B: "び",
  C: "し",
  D: "ど",
  E: "え",
  F: "ふ",
  G: "ぐ",
  H: "は",
  I: "い",
  J: "じ",
  K: "け",
  L: "る",
  M: "む",
  N: "ん",
  O: "お",
  P: "ぷ",
  Q: "く",
  R: "り",
  S: "す",
  T: "と",
  U: "う",
  V: "ゔ",
  W: "わ",
  X: "ち",
  Y: "よ",
  Z: "ず",
};

// Chinese characters style
const chineseStyle: UnicodeMapping = {
  A: "阿",
  B: "贝",
  C: "西",
  D: "德",
  E: "额",
  F: "弗",
  G: "高",
  H: "华",
  I: "艾",
  J: "杰",
  K: "凯",
  L: "立",
  M: "马",
  N: "恩",
  O: "欧",
  P: "配",
  Q: "奇",
  R: "热",
  S: "史",
  T: "台",
  U: "乌",
  V: "维",
  W: "威",
  X: "西",
  Y: "耶",
  Z: "泽",
};

// Transform function that applies a mapping to text
function transformWithMapping(text: string, mapping: UnicodeMapping): string {
  return text
    .split("")
    .map((char) => mapping[char] || char)
    .join("");
}

// Special transformation functions
function transformSpaced(text: string): string {
  return text.split("").join(" ");
}

function transformUpsideDown(text: string): string {
  const upsideDownMap: UnicodeMapping = {
    a: "ɐ",
    b: "q",
    c: "ɔ",
    d: "p",
    e: "ǝ",
    f: "ɟ",
    g: "ƃ",
    h: "ɥ",
    i: "ᴉ",
    j: "ɾ",
    k: "ʞ",
    l: "l",
    m: "ɯ",
    n: "u",
    o: "o",
    p: "d",
    q: "b",
    r: "ɹ",
    s: "s",
    t: "ʇ",
    u: "n",
    v: "ʌ",
    w: "ʍ",
    x: "x",
    y: "ʎ",
    z: "z",
    A: "∀",
    B: "ᗺ",
    C: "Ɔ",
    D: "ᗡ",
    E: "Ǝ",
    F: "ᖴ",
    G: "פ",
    H: "H",
    I: "I",
    J: "ſ",
    K: "ʞ",
    L: "˥",
    M: "W",
    N: "N",
    O: "O",
    P: "Ԁ",
    Q: "Q",
    R: "ᴿ",
    S: "S",
    T: "┴",
    U: "∩",
    V: "Λ",
    W: "M",
    X: "X",
    Y: "⅄",
    Z: "Z",
    "0": "0",
    "1": "Ɩ",
    "2": "ᄅ",
    "3": "Ɛ",
    "4": "ㄣ",
    "5": "ϛ",
    "6": "9",
    "7": "ㄥ",
    "8": "8",
    "9": "6",
    ".": "˙",
    ",": "'",
    "?": "¿",
    "!": "¡",
    '"': "„",
    "'": "‛",
    "(": ")",
    ")": "(",
    "[": "]",
    "]": "[",
    "{": "}",
    "}": "{",
    "<": ">",
    ">": "<",
    "&": "⅋",
  };

  return text
    .split("")
    .reverse()
    .map((char) => upsideDownMap[char] || char)
    .join("");
}

function transformStrike(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0336")
    .join("");
}

function transformUnderline(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0332")
    .join("");
}

function transformSlash(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0337")
    .join("");
}

function transformWave(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u033F")
    .join("");
}

function transformZalgo(text: string): string {
  const zalgoChars = [
    "\u030d",
    "\u030e",
    "\u0304",
    "\u0305",
    "\u033f",
    "\u0311",
    "\u0306",
    "\u0310",
    "\u0352",
    "\u0357",
    "\u0351",
    "\u0307",
    "\u0308",
    "\u030a",
    "\u0342",
    "\u0343",
    "\u0344",
    "\u034a",
    "\u034b",
    "\u034c",
    "\u0303",
    "\u0302",
    "\u030c",
    "\u0350",
  ];

  return text
    .split("")
    .map((char) => {
      if (/[a-zA-Z]/.test(char)) {
        const numMarks = Math.floor(Math.random() * 3) + 1;
        let result = char;
        for (let i = 0; i < numMarks; i++) {
          result += zalgoChars[Math.floor(Math.random() * zalgoChars.length)];
        }
        return result;
      }
      return char;
    })
    .join("");
}

function transformCurrency(text: string): string {
  const currencyMap: UnicodeMapping = {
    A: "₳",
    B: "฿",
    C: "₡",
    D: "₫",
    E: "€",
    F: "₣",
    G: "₲",
    H: "Ħ",
    I: "I",
    J: "J",
    K: "₭",
    L: "Ł",
    M: "₼",
    N: "₦",
    O: "Ø",
    P: "₽",
    Q: "Q",
    R: "₹",
    S: "$",
    T: "₮",
    U: "Ʉ",
    V: "V",
    W: "₩",
    X: "Ӿ",
    Y: "¥",
    Z: "Ƶ",
    a: "ą",
    b: "ƀ",
    c: "¢",
    d: "đ",
    e: "є",
    f: "ƒ",
    g: "ǥ",
    h: "ħ",
    i: "i",
    j: "j",
    k: "ķ",
    l: "ł",
    m: "m",
    n: "η",
    o: "ø",
    p: "ρ",
    q: "q",
    r: "я",
    s: "ş",
    t: "ţ",
    u: "µ",
    v: "v",
    w: "w",
    x: "χ",
    y: "¥",
    z: "ž",
  };

  return transformWithMapping(text, currencyMap);
}

// Serif style using combining macron below (U+0331) for a classical/formal appearance
function transformSerif(text: string): string {
  return text
    .split("")
    .map((char) => {
      // Only add combining character to letters, not spaces or punctuation
      if (/[a-zA-Z]/.test(char)) {
        return char + "\u0331";
      }
      return char;
    })
    .join("");
}

function transformDotted(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0323")
    .join("");
}

function transformDoubleUnderline(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0333")
    .join("");
}

function transformOverline(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0305")
    .join("");
}

function transformDiaeresis(text: string): string {
  return text
    .split("")
    .map((char) => char + "\u0308")
    .join("");
}

function transformInverted(text: string): string {
  return "¡" + text + "¿";
}

// Symbol decoration functions
function transformStars(text: string): string {
  return `✨ ${text} ✨`;
}

function transformHearts(text: string): string {
  return `💖 ${text} 💖`;
}

function transformArrows(text: string): string {
  return `➤ ${text} ➤`;
}

function transformDiamonds(text: string): string {
  return `💎 ${text} 💎`;
}

function transformFlowers(text: string): string {
  return `🌸 ${text} 🌸`;
}

function transformCrowns(text: string): string {
  return `👑 ${text} 👑`;
}

// ASCII art functions
function transformAsciiBox(text: string): string {
  const line = "─".repeat(text.length + 2);
  return `┌${line}┐\n│ ${text} │\n└${line}┘`;
}

function transformAsciiStars(text: string): string {
  const stars = "*".repeat(text.length + 4);
  return `${stars}\n* ${text} *\n${stars}`;
}

function transformAsciiBorder(text: string): string {
  return `═══ ${text} ═══`;
}

// Advanced star decoration functions
function transformStarBasic(text: string): string {
  return `ミ★ ${text} ★彡`;
}

function transformStarDouble(text: string): string {
  return `╰•★★ ${text} ★★•╯`;
}

function transformStarOrnate(text: string): string {
  return `꧁•⊹٭${text}٭⊹•꧂`;
}

function transformStarCelestial(text: string): string {
  return `°⨳°·..·°⨳°⊹٭ ${text} ٭⊹°⨳°·..·°⨳°`;
}

function transformStarElegant(text: string): string {
  return `¸.·✩·.¸¸.·¯⍣✩ ${text} ✩⍣¯·.¸¸.·✩·.¸`;
}

function transformStarDream(text: string): string {
  return `\`✵•.¸,✵°✵.｡.✰ ${text} ✰.｡.✵°✵,¸.•✵\``;
}

function transformStarClassic(text: string): string {
  return `·.★·.·´¯\`·.·★ ${text} ★·.·´¯\`·.·★.·`;
}

function transformStarMystic(text: string): string {
  return `¨˜ˆ"°⍣~•✡⊹٭„¸ ${text} ¸„٭⊹✡•~⍣°"ˆ˜¨`;
}

function transformStarGentle(text: string): string {
  return `°•.•°¤*✬.•°°• ${text} °•°•.✬*¤°•.•°`;
}

function transformStarReverse(text: string): string {
  return `¸„٭⊹✡•~⍣°"ˆ˜¨ ${text} ¨˜ˆ"°⍣~•✡⊹٭„¸`;
}

function transformStarSimple(text: string): string {
  return `★¸.•☆•.¸★ ${text} ★⡀.•☆•.★`;
}

function transformStarLuxury(text: string): string {
  return `٭⊹¤.•⨳•.*☆✬ ${text} ✬☆*.•⨳•.¤⊹٭`;
}

// Heart decoration functions
function transformHeartBasic(text: string): string {
  return `ミ💖 ${text} 💖彡`;
}

function transformHeartDouble(text: string): string {
  return `෴❤️෴ ෴❤️෴ ${text} ෴❤️෴ ෴❤️෴`;
}

function transformHeartWave(text: string): string {
  return `*¸ „„.•~¹°"ˆ˜¨♡ ${text} ♡¨˜ˆ"°¹~•.„¸*`;
}

function transformHeartPink(text: string): string {
  return `💖´ *•.¸♥¸.•** ${text} **•.¸♥¸.•*´💖`;
}

function transformHeartRounded(text: string): string {
  return `•¤»((¯♥¯))«¤• ${text} •¤»((¯♥¯))«¤•`;
}

function transformHeartPattern(text: string): string {
  return `♥❤♥.¸•❤\`.¸•❤\`.¸ ${text} ¸.\`❤•¸.\`❤•¸.♥❤♥`;
}

function transformHeartMusic(text: string): string {
  return `(¯\`'•.¸❤♫♪♥(◠‿◠)♥♫♪❤¸.•'\´¯)${text}(¯\`'•.¸❤♫♪♥(◠‿◠)♥♫♪❤¸.•'\´¯)`;
}

function transformHeartRepeat(text: string): string {
  return `❤♡❤♡❤♡❤♡❤♡❤♡❤♡ ${text} ♡❤♡❤♡❤♡❤♡❤♡❤♡❤`;
}

function transformHeartSimple(text: string): string {
  return `◦•●❤♡ ${text} ♡❤●•◦`;
}

function transformHeartFloral(text: string): string {
  return `❤꧁ღ⊱♥ ${text} ♥⊱ღ꧂❤`;
}

function transformHeartElaborate(text: string): string {
  return `ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥ ${text} ♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡`;
}

function transformHeartCute(text: string): string {
  return `🌸ξξ(∵❤◡❤∵)ξξ·¯·♩¸ ${text} ¸♩·¯·ξξ(∵❤◡❤∵)ξξ🌸`;
}

// Decorative pattern functions
function transformDecorativeStars(text: string): string {
  return `꙳¤*٭⁎﹡꙳＊ ${text} ＊꙳﹡⁎٭*¤꙳`;
}

function transformMusicalNotes(text: string): string {
  return `♫♪♩·.¸¸.·♩♪♫ ${text} ♫♪♩·.¸¸.·♩♪♫`;
}

function transformBlockBars(text: string): string {
  return `▌│█║▌║▌║ ${text} ║▌║▌║█│▌`;
}

function transformProgressiveBars(text: string): string {
  return `▁ ▂ ▄ ▅ ▆ ▇ █ ${text} █ ▇ ▆ ▅ ▄ ▂ ▁`;
}

function transformShadedBlocks(text: string): string {
  return `▓▒░ ${text} ░▒▓`;
}

function transformTextPattern(text: string): string {
  return `,¡i|¹i¡¡i¹|i¡, ${text} ,¡i|¹i¡¡i¹|i¡,`;
}

function transformMoonStars(text: string): string {
  return `☆.´ \`. ☽¸.☆, ${text} ,☆.¸☽ .\` ´.☆`;
}

function transformCircleDots(text: string): string {
  return `•°o.O•°o.O ${text} O.o°•O.o°•`;
}

function transformOrnamental(text: string): string {
  return `ஜ۩۞۩ஜ ${text} ஜ۩۞۩ஜ`;
}

// Joined text functions
function transformWaveJoined(text: string): string {
  const result = text.split("").join("∿");
  return `〜${result}〜`;
}

function transformBlockJoined(text: string): string {
  return text.split("").join("░");
}

function transformHeartJoined(text: string): string {
  return text.split("").join("❥");
}

function transformArrowJoined(text: string): string {
  return text.split("").join("⊶");
}

function transformStarJoined(text: string): string {
  return text.split("").join("∗");
}

function transformCrossJoined(text: string): string {
  return text.split("").join("⨳");
}

function transformRingJoined(text: string): string {
  return text
    .split("")
    .map((char) => char + "̊⫶")
    .join("");
}

function transformComplexJoined1(text: string): string {
  return text
    .split("")
    .map((char) => char + "͛⦚")
    .join("");
}

function transformComplexJoined2(text: string): string {
  return text
    .split("")
    .map((char) => char + "͎͍͐￫")
    .join("");
}

// Emoticon text functions
function transformBracketEmoticon(text: string): string {
  return `=-[~_-¯ ${text} ¯-_~]-`;
}

function transformCuteEmoticon(text: string): string {
  return `${text} (ㆆᴗㆆ)`;
}

function transformHappyFlower(text: string): string {
  return `${text} (˶◕‿◕)ノ✿`;
}

function transformShrugEmoticon(text: string): string {
  return `¯\\_(ツ)_/¯ ${text} ¯\\_(ツ)_/¯`;
}

function transformWideEyes(text: string): string {
  return `(◉‿◉) ${text} (◉‿◉)`;
}

function transformHeartEyes(text: string): string {
  return `✿♥‿♥✿ ${text} ✿♥‿♥✿`;
}

function transformHeartCheeks(text: string): string {
  return `(❣•‿•❣) ${text} (❣•‿•❣)`;
}

function transformSubtleEmoticon(text: string): string {
  return `(ͽ․̫ͼ) ${text} (ͽ․̫ͼ)`;
}

function transformNestedEmoticon(text: string): string {
  return `(⦁(⦁_( ${text} )_⦁)⦁)`;
}

// Adorable text functions
function transformAdorableMusic(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `♫♪ ${scriptText.replace("o", "💍o")} ♫♪ 🐏 ⋆ 🐯 ⋆ 🐚`;
}

function transformAdorableCandy(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `${scriptText.replace("o", "🍬o")} 🌌｡`;
}

function transformAdorableHeart(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `♥ ${scriptText.replace("o", "🍩o")} ♥ ★❈✴`;
}

function transformAdorableFlower(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `❀ ${scriptText.replace("o", "😍o")} ❀ ▌│█║▌║▌║`;
}

function transformAdorableSymbol(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `᯽ ${scriptText.replace("o", "❁o")} ᯽ 🐏 ⋆ 🐷`;
}

function transformAdorableFleur(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `⚜ ${scriptText.replace("o", "🌸o")} ⚜ :\`✩`;
}

function transformAdorableShamrock(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `☘ ${scriptText.replace("o", "💗o")} ☘ 🐌 ⋆ 🐐`;
}

function transformAdorableBrackets(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `꧁꫱꧂ ${scriptText.replace("o", "😍o")} ꧁꫱꧂ 🐼 ⋆ 🐞`;
}

function transformAdorablePetal(text: string): string {
  const scriptText = transformWithMapping(text, script);
  return `ꕥ ${scriptText.replace("o", "🍑o")} ꕥ 🐫 ⋆ 🐷 ⋆ 🐸`;
}

// Wild text functions
function transformWildCircles(text: string): string {
  // Mix different font styles randomly
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [circled, mathBold, fullwidth, script];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `.o0×X×0o. ${wildText} .o0×X×0o.`;
}

function transformWildEmoji1(text: string): string {
  // Mix bold script and other wild styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [boldScript, circled, fullwidth, mathBold];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `💝♢ ${wildText} 💗♜`;
}

function transformWildEmoji2(text: string): string {
  // Mix italic and bold with random styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [mathBoldItalic, script, mathSans, boldScript];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `✌🍟 ${wildText} 🐲🐨`;
}

function transformWildBorder(text: string): string {
  // Mix fraktur and other decorative styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [fraktur, boldScript, circled, mathBold];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `¸,ø¤º°\`°º¤ø,¸¸,ø¤º° ${wildText} °º¤ø,¸¸,ø¤º°\`°º¤ø,¸`;
}

function transformWildFaces(text: string): string {
  // Mix bold and sans styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [mathBold, script, circled, mathSansBold];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `👣😲 ${wildText} 🐸♢`;
}

function transformWildSpooky(text: string): string {
  // Mix double struck and script styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [doubleStruck, mathBold, script, boldScript];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `🎀ඏ ${wildText} 😈👤`;
}

function transformWildCandy(text: string): string {
  // Mix various mathematical styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [mathBoldItalic, doubleStruck, boldFraktur, script];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `💢🍬 ${wildText} 🍫💎`;
}

function transformWildMusic(text: string): string {
  // Mix script and double struck
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [script, mathBold, doubleStruck, boldScript];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `♬🍬 ${wildText} 🍫🐲`;
}

function transformWildAlien(text: string): string {
  // Mix all available wild styles
  const wildText = text
    .split("")
    .map((char, i) => {
      const styles = [script, doubleStruck, mathBold, boldFraktur];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `♟👽 ${wildText} 🐠😂`;
}

// Christmas text functions
function transformChristmasSanta(text: string): string {
  // Use Thai-inspired characters for festive look
  const festiveMapping: { [key: string]: string } = {
    a: "ค",
    b: "ฟ",
    c: "ς",
    d: "໐",
    e: "ē",
    f: "f",
    g: "ງ",
    h: "h",
    i: "i",
    j: "j",
    k: "k",
    l: "l",
    m: "m",
    n: "ຖ",
    o: "໐",
    p: "p",
    q: "q",
    r: "r",
    s: "ş",
    t: "tē",
    u: "u",
    v: "v",
    w: "w",
    x: "x",
    y: "ý",
    z: "z",
  };
  const festiveText = text
    .split("")
    .map((char) => festiveMapping[char.toLowerCase()] || char)
    .join("");
  return `🎅 ${festiveText} 🎅`;
}

function transformChristmasSnowman(text: string): string {
  // Similar festive style for snowman theme
  const festiveMapping: { [key: string]: string } = {
    a: "ค",
    b: "ฟ",
    c: "ς",
    d: "໐",
    e: "ē",
    f: "f",
    g: "ງ",
    h: "h",
    i: "i",
    j: "j",
    k: "k",
    l: "l",
    m: "m",
    n: "ຖ",
    o: "໐",
    p: "p",
    q: "q",
    r: "r",
    s: "ş",
    t: "tē",
    u: "u",
    v: "v",
    w: "w",
    x: "x",
    y: "ý",
    z: "z",
  };
  const festiveText = text
    .split("")
    .map((char) => festiveMapping[char.toLowerCase()] || char)
    .join("");
  return `☃️ ${festiveText} ☃️`;
}

function transformChristmasSnowflake(text: string): string {
  // Use combining diacritical marks for icy effect
  const icyMapping: { [key: string]: string } = {
    a: "å",
    b: "ß",
    c: "ç",
    d: "ð",
    e: "ê",
    f: "f",
    g: "G",
    h: "h",
    i: "î",
    j: "j",
    k: "k",
    l: "l",
    m: "m",
    n: "ñ",
    o: "ð",
    p: "p",
    q: "q",
    r: "r",
    s: "ş",
    t: "†",
    u: "û",
    v: "v",
    w: "w",
    x: "x",
    y: "ÿ",
    z: "z",
  };
  const icyText = text
    .split("")
    .map((char) => icyMapping[char.toLowerCase()] || char)
    .join("");
  return `❄️ ${icyText} ❄️`;
}

function transformChristmasStocking(text: string): string {
  // Use Cherokee-inspired characters for unique Christmas look
  const cherokeeMapping: { [key: string]: string } = {
    A: "Ꭺ",
    B: "Ᏸ",
    C: "Ꮯ",
    D: "Ꭰ",
    E: "Ꭼ",
    F: "Ꮀ",
    G: "Ꮆ",
    H: "Ꮋ",
    I: "Ꭸ",
    J: "Ꮰ",
    K: "Ꮶ",
    L: "Ꮮ",
    M: "Ꮇ",
    N: "Ꮑ",
    O: "Ꮻ",
    P: "Ꮲ",
    Q: "Ꮕ",
    R: "Ꮢ",
    S: "Ꮥ",
    T: "Ꮏ",
    U: "Ꮜ",
    V: "Ꮙ",
    W: "Ꮤ",
    X: "Ꮭ",
    Y: "Ꮍ",
    Z: "Ꮓ",
  };
  const cherokeeText = text
    .toUpperCase()
    .split("")
    .map((char) => cherokeeMapping[char] || char)
    .join("");
  return `🧦 ${cherokeeText} 🧦`;
}

function transformChristmasStars(text: string): string {
  // Use the existing star decoration pattern
  const gotText = text
    .split("")
    .map((char, i) => {
      const styles = [script, mathBold];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `¸.·✩·.¸¸.·¯⍣✩ ${gotText} ✩⍣¯·.¸¸.·✩·.¸`;
}

function transformChristmasGifts(text: string): string {
  // Use decorative style with bell separators
  const giftText = text
    .split("")
    .map((char, i) => {
      const styles = [script, mathBold];
      const style = styles[i % styles.length];
      return style[char] || char;
    })
    .join("");
  return `🎁 ᯼🔔᯼🔔 ${giftText} 🔔🏮🔔🏮🎁`;
}

// Emoji combination transformer
function transformEmojiMix(text: string): string {
  return text
    .split("")
    .map((char) => {
      if (emojiLetters[char.toUpperCase()]) {
        return emojiLetters[char.toUpperCase()];
      } else if (emojiNumbers[char]) {
        return emojiNumbers[char];
      }
      return char;
    })
    .join("");
}

// Main transformer function
// === NEW TEXT CASE TRANSFORMATIONS ===

// Alternating case: aLtErNaTiNg CaSe
function transformAlternatingCase(text: string): string {
  return text
    .split("")
    .map((char, index) => {
      if (/[a-zA-Z]/.test(char)) {
        return index % 2 === 0 ? char.toLowerCase() : char.toUpperCase();
      }
      return char;
    })
    .join("");
}

// Inverted alternating case: AlTeRnAtInG cAsE
function transformInvertedAlternating(text: string): string {
  return text
    .split("")
    .map((char, index) => {
      if (/[a-zA-Z]/.test(char)) {
        return index % 2 === 0 ? char.toUpperCase() : char.toLowerCase();
      }
      return char;
    })
    .join("");
}

// camelCase transformation
function transformCamelCase(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, char) => char.toUpperCase())
    .replace(/^[A-Z]/, (char) => char.toLowerCase());
}

// PascalCase transformation
function transformPascalCase(text: string): string {
  return text
    .toLowerCase()
    .replace(/(?:^|[^a-zA-Z0-9])(.)/g, (_, char) => char.toUpperCase())
    .replace(/[^a-zA-Z0-9]/g, "");
}

// snake_case transformation
function transformSnakeCase(text: string): string {
  return text
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/[\s-]+/g, "_")
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, "")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}

// kebab-case transformation
function transformKebabCase(text: string): string {
  return text
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

// CONSTANT_CASE transformation
function transformConstantCase(text: string): string {
  return text
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/[\s-]+/g, "_")
    .toUpperCase()
    .replace(/[^A-Z0-9_]/g, "")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}

// Reverse text: txeT
function transformReverse(text: string): string {
  return text.split("").reverse().join("");
}

// Reverse words but keep word order: sihT si desrever
function transformReverseWords(text: string): string {
  return text
    .split(" ")
    .map((word) => word.split("").reverse().join(""))
    .join(" ");
}

// Mirror text using special Unicode mirrored characters
const mirrorMap: UnicodeMapping = {
  a: "ɒ",
  b: "d",
  c: "ɔ",
  d: "b",
  e: "ɘ",
  f: "ꟻ",
  g: "ǫ",
  h: "ʜ",
  i: "i",
  j: "ꞁ",
  k: "ʞ",
  l: "l",
  m: "m",
  n: "ᴎ",
  o: "o",
  p: "q",
  q: "p",
  r: "ɿ",
  s: "ꙅ",
  t: "ƚ",
  u: "u",
  v: "v",
  w: "w",
  x: "x",
  y: "ʏ",
  z: "ƹ",
  A: "A",
  B: "ᙠ",
  C: "Ɔ",
  D: "ᗡ",
  E: "Ǝ",
  F: "ꟻ",
  G: "Ꭾ",
  H: "H",
  I: "I",
  J: "Ⴑ",
  K: "ꓘ",
  L: "⅃",
  M: "M",
  N: "ᴎ",
  O: "O",
  P: "ꟼ",
  Q: "Ọ",
  R: "ᴙ",
  S: "Ꙅ",
  T: "T",
  U: "U",
  V: "V",
  W: "W",
  X: "X",
  Y: "Y",
  Z: "Ƹ",
  "1": "߁",
  "2": "ς",
  "3": "Ɛ",
  "4": "߂",
  "5": "ट",
  "6": "მ",
  "7": "ㄥ",
  "8": "8",
  "9": "ᑫ",
  "0": "0",
};

function transformMirror(text: string): string {
  return text
    .split("")
    .reverse()
    .map((char) => mirrorMap[char] || char)
    .join("");
}

// Leet speak (1337 5p34k)
const leetMap: UnicodeMapping = {
  a: "4",
  A: "4",
  b: "8",
  B: "8",
  e: "3",
  E: "3",
  g: "9",
  G: "9",
  i: "1",
  I: "1",
  l: "1",
  L: "1",
  o: "0",
  O: "0",
  s: "5",
  S: "5",
  t: "7",
  T: "7",
  z: "2",
  Z: "2",
};

function transformLeetSpeak(text: string): string {
  return text
    .split("")
    .map((char) => leetMap[char] || char)
    .join("");
}

// Advanced leet speak
const leetAdvancedMap: UnicodeMapping = {
  a: "@",
  A: "@",
  b: "|3",
  B: "|3",
  c: "(",
  C: "(",
  d: "|)",
  D: "|)",
  e: "3",
  E: "3",
  f: "|=",
  F: "|=",
  g: "9",
  G: "9",
  h: "|-|",
  H: "|-|",
  i: "!",
  I: "!",
  j: "_|",
  J: "_|",
  k: "|<",
  K: "|<",
  l: "|_",
  L: "|_",
  m: "|\\/|",
  M: "|\\/|",
  n: "|\\|",
  N: "|\\|",
  o: "0",
  O: "0",
  p: "|*",
  P: "|*",
  q: "0,",
  Q: "0,",
  r: "|2",
  R: "|2",
  s: "$",
  S: "$",
  t: "+",
  T: "+",
  u: "|_|",
  U: "|_|",
  v: "\\/",
  V: "\\/",
  w: "\\/\\/",
  W: "\\/\\/",
  x: "><",
  X: "><",
  y: "`/",
  Y: "`/",
  z: "2",
  Z: "2",
};

function transformLeetAdvanced(text: string): string {
  return text
    .split("")
    .map((char) => leetAdvancedMap[char] || char)
    .join("");
}

// Mocking SpongeBob style (random alternation)
function transformMockingSpongebob(text: string): string {
  let isUpper = false;
  return text
    .split("")
    .map((char) => {
      if (/[a-zA-Z]/.test(char)) {
        isUpper = Math.random() > 0.5;
        return isUpper ? char.toUpperCase() : char.toLowerCase();
      }
      return char;
    })
    .join("");
}

// Wide aesthetic text (with full-width spaces)
function transformWideAesthetic(text: string): string {
  return text
    .split("")
    .map((char) => {
      if (char === " ") return "　"; // Full-width space
      const code = char.charCodeAt(0);
      if (code >= 33 && code <= 126) {
        return String.fromCharCode(code + 65248); // Convert to full-width
      }
      return char;
    })
    .join("");
}

// Vapor wave style (spaced + full width)
function transformVaporwave(text: string): string {
  return text
    .toUpperCase()
    .split("")
    .map((char) => {
      if (char === " ") return "  ";
      const code = char.charCodeAt(0);
      if (code >= 33 && code <= 126) {
        return String.fromCharCode(code + 65248);
      }
      return char;
    })
    .join(" ");
}

// Binary representation
function transformBinary(text: string): string {
  return text
    .split("")
    .map((char) => {
      const binary = char.charCodeAt(0).toString(2).padStart(8, "0");
      return binary;
    })
    .join(" ");
}

// Morse code
const morseMap: { [key: string]: string } = {
  A: ".-",
  B: "-...",
  C: "-.-.",
  D: "-..",
  E: ".",
  F: "..-.",
  G: "--.",
  H: "....",
  I: "..",
  J: ".---",
  K: "-.-",
  L: ".-..",
  M: "--",
  N: "-.",
  O: "---",
  P: ".--.",
  Q: "--.-",
  R: ".-.",
  S: "...",
  T: "-",
  U: "..-",
  V: "...-",
  W: ".--",
  X: "-..-",
  Y: "-.--",
  Z: "--..",
  "0": "-----",
  "1": ".----",
  "2": "..---",
  "3": "...--",
  "4": "....-",
  "5": ".....",
  "6": "-....",
  "7": "--...",
  "8": "---..",
  "9": "----.",
  " ": "/",
  ".": ".-.-.-",
  ",": "--..--",
  "?": "..--..",
  "!": "-.-.--",
};

function transformMorse(text: string): string {
  return text
    .toUpperCase()
    .split("")
    .map((char) => morseMap[char] || char)
    .join(" ");
}

// Title Case
function transformTitleCase(text: string): string {
  return text.toLowerCase().replace(/(?:^|\s)\w/g, (char) => char.toUpperCase());
}

// Sentence case
function transformSentenceCase(text: string): string {
  return text.toLowerCase().replace(/(^\s*\w|[.!?]\s+\w)/g, (char) => char.toUpperCase());
}

// Toggle case (swap upper/lower)
function transformToggleCase(text: string): string {
  return text
    .split("")
    .map((char) => {
      if (char === char.toUpperCase()) return char.toLowerCase();
      if (char === char.toLowerCase()) return char.toUpperCase();
      return char;
    })
    .join("");
}

// Clap emoji between words
function transformClapEmoji(text: string): string {
  return text
    .split(" ")
    .filter((w) => w)
    .join(" 👏 ");
}

// Fire emoji border
function transformFireBorder(text: string): string {
  return `🔥 ${text} 🔥`;
}

// Sparkles border
function transformSparklesBorder(text: string): string {
  return `✨ ${text} ✨`;
}

// ASCII Art - Block Letters
const blockLetters: { [key: string]: string[] } = {
  A: ["█▀█", "█▀█", "▀ ▀"],
  B: ["█▀▄", "█▀▄", "▀▀ "],
  C: ["█▀▀", "█  ", "▀▀▀"],
  D: ["█▀▄", "█ █", "▀▀ "],
  E: ["█▀▀", "█▀▀", "▀▀▀"],
  F: ["█▀▀", "█▀▀", "▀  "],
  G: ["█▀▀", "█ █", "▀▀▀"],
  H: ["█ █", "█▀█", "▀ ▀"],
  I: ["▀█▀", " █ ", "▀▀▀"],
  J: ["  █", "  █", "▀▀ "],
  K: ["█ █", "█▀▄", "▀ ▀"],
  L: ["█  ", "█  ", "▀▀▀"],
  M: ["█▄█", "█ █", "▀ ▀"],
  N: ["█▀█", "█ █", "▀ ▀"],
  O: ["█▀█", "█ █", "▀▀▀"],
  P: ["█▀█", "█▀▀", "▀  "],
  Q: ["█▀█", "█ █", "▀▀▄"],
  R: ["█▀█", "█▀▄", "▀ ▀"],
  S: ["█▀▀", "▀▀█", "▀▀▀"],
  T: ["▀█▀", " █ ", " ▀ "],
  U: ["█ █", "█ █", "▀▀▀"],
  V: ["█ █", "█ █", " ▀ "],
  W: ["█ █", "█ █", "▀▄▀"],
  X: ["█ █", " ▀ ", "█ █"],
  Y: ["█ █", " █ ", " ▀ "],
  Z: ["▀▀█", " █ ", "█▀▀"],
  " ": ["   ", "   ", "   "],
};

function transformBlockLetters(text: string): string {
  const upper = text.toUpperCase();
  const lines = ["", "", ""];
  for (const char of upper) {
    const block = blockLetters[char] || ["   ", "   ", "   "];
    lines[0] += block[0] + " ";
    lines[1] += block[1] + " ";
    lines[2] += block[2] + " ";
  }
  return lines.join("\n");
}

// Dot Matrix Style - using actual braille patterns that represent letters
function transformDotMatrix(text: string): string {
  const brailleMap: { [key: string]: string } = {
    A: "⠁",
    B: "⠃",
    C: "⠉",
    D: "⠙",
    E: "⠑",
    F: "⠋",
    G: "⠛",
    H: "⠓",
    I: "⠊",
    J: "⠚",
    K: "⠅",
    L: "⠇",
    M: "⠍",
    N: "⠝",
    O: "⠕",
    P: "⠏",
    Q: "⠟",
    R: "⠗",
    S: "⠎",
    T: "⠞",
    U: "⠥",
    V: "⠧",
    W: "⠺",
    X: "⠭",
    Y: "⠽",
    Z: "⠵",
    " ": " ",
    a: "⠁",
    b: "⠃",
    c: "⠉",
    d: "⠙",
    e: "⠑",
    f: "⠋",
    g: "⠛",
    h: "⠓",
    i: "⠊",
    j: "⠚",
    k: "⠅",
    l: "⠇",
    m: "⠍",
    n: "⠝",
    o: "⠕",
    p: "⠏",
    q: "⠟",
    r: "⠗",
    s: "⠎",
    t: "⠞",
    u: "⠥",
    v: "⠧",
    w: "⠺",
    x: "⠭",
    y: "⠽",
    z: "⠵",
    "0": "⠴",
    "1": "⠂",
    "2": "⠆",
    "3": "⠒",
    "4": "⠲",
    "5": "⠢",
    "6": "⠖",
    "7": "⠶",
    "8": "⠦",
    "9": "⠔",
    ".": "⠲",
    ",": "⠂",
    "!": "⠖",
    "?": "⠦",
    "-": "⠤",
  };
  return text
    .split("")
    .map((c) => brailleMap[c] || c)
    .join("");
}

// Gradient Effects - Light to Heavy
function transformGradientLight(text: string): string {
  const gradients = ["░", "▒", "▓", "█"];
  return (
    text
      .split("")
      .map((char, i) => {
        if (char === " ") return " ";
        const gradientIndex = Math.floor((i / text.length) * gradients.length);
        return gradients[Math.min(gradientIndex, gradients.length - 1)];
      })
      .join("") +
    " " +
    text
  );
}

function transformGradientHeavy(text: string): string {
  const gradients = ["█", "▓", "▒", "░"];
  return (
    text
      .split("")
      .map((char, i) => {
        if (char === " ") return " ";
        const gradientIndex = Math.floor((i / text.length) * gradients.length);
        return gradients[Math.min(gradientIndex, gradients.length - 1)];
      })
      .join("") +
    " " +
    text
  );
}

// Rainbow Circle Letters
function transformRainbowCircles(text: string): string {
  const colors = ["🔴", "🟠", "🟡", "🟢", "🔵", "🟣"];
  return (
    text
      .split("")
      .map((char, i) => {
        if (char === " ") return " ";
        return colors[i % colors.length];
      })
      .join("") +
    " " +
    text
  );
}

// Progressive Stars
function transformProgressiveStars(text: string): string {
  const stars = ["☆", "✧", "✦", "★", "✪", "✯"];
  return text
    .split("")
    .map((char, i) => {
      if (char === " ") return " ";
      const starIndex = Math.floor((i / text.length) * stars.length);
      return stars[Math.min(starIndex, stars.length - 1)];
    })
    .join("");
}

// Invisible/Hidden Text with Zero-Width Characters
function transformInvisibleSpaces(text: string): string {
  // Insert zero-width spaces between each character
  const zwsp = "\u200B"; // Zero-width space
  return text.split("").join(zwsp);
}

function transformInvisibleJoiner(text: string): string {
  // Insert zero-width joiners
  const zwj = "\u200D"; // Zero-width joiner
  return text.split("").join(zwj);
}

function transformWatermark(text: string): string {
  // Add invisible watermark at the end
  const zwsp = "\u200B";
  const zwnj = "\u200C";
  // Encode "TEXT.ONL" as invisible pattern
  const watermark = zwsp + zwnj + zwsp + zwsp + zwnj + zwnj + zwsp + zwnj;
  return text + watermark;
}

// Kaomoji Wraps
function transformKaomojiHappy(text: string): string {
  return `(◕‿◕) ${text} (◕‿◕)`;
}

function transformKaomojiCat(text: string): string {
  return `=^.^= ${text} =^.^=`;
}

function transformKaomojiStar(text: string): string {
  return `☆*:.｡.o(≧▽≦)o.｡.:*☆ ${text} ☆*:.｡.o(≧▽≦)o.｡.:*☆`;
}

function transformKaomojiBear(text: string): string {
  return `ʕ•ᴥ•ʔ ${text} ʕ•ᴥ•ʔ`;
}

function transformKaomojiFlip(text: string): string {
  return `(╯°□°)╯︵ ${text}`;
}

function transformKaomojiShrug(text: string): string {
  return `¯\\_(ツ)_/¯ ${text} ¯\\_(ツ)_/¯`;
}

// Box Drawing
function transformBoxLight(text: string): string {
  const len = text.length + 2;
  const top = "┌" + "─".repeat(len) + "┐";
  const mid = "│ " + text + " │";
  const bot = "└" + "─".repeat(len) + "┘";
  return `${top}\n${mid}\n${bot}`;
}

function transformBoxDouble(text: string): string {
  const len = text.length + 2;
  const top = "╔" + "═".repeat(len) + "╗";
  const mid = "║ " + text + " ║";
  const bot = "╚" + "═".repeat(len) + "╝";
  return `${top}\n${mid}\n${bot}`;
}

function transformBoxRound(text: string): string {
  const len = text.length + 2;
  const top = "╭" + "─".repeat(len) + "╮";
  const mid = "│ " + text + " │";
  const bot = "╰" + "─".repeat(len) + "╯";
  return `${top}\n${mid}\n${bot}`;
}

// Typewriter Effect (with dots)
function transformTypewriter(text: string): string {
  return text + "...";
}

// Glitch Text
function transformGlitch(text: string): string {
  const glitchChars = ["̸", "̵", "̶", "̷", "̴"];
  return text
    .split("")
    .map((char) => {
      if (char === " ") return " ";
      const glitch = glitchChars[Math.floor(Math.random() * glitchChars.length)];
      return char + glitch;
    })
    .join("");
}

// Creepy Zalgo Light
function transformZalgoLight(text: string): string {
  const zalgoUp = ["̍", "̎", "̄", "̅", "̿", "̑", "̆", "̐"];
  const zalgoDown = ["̖", "̗", "̘", "̙", "̜", "̝", "̞", "̟"];
  return text
    .split("")
    .map((char) => {
      if (char === " ") return " ";
      const up = zalgoUp[Math.floor(Math.random() * zalgoUp.length)];
      const down = zalgoDown[Math.floor(Math.random() * zalgoDown.length)];
      return char + up + down;
    })
    .join("");
}

// Bubble Wrap
function transformBubbleWrap(text: string): string {
  return "○ " + text.split("").join(" ○ ") + " ○";
}

// Hashtag Style
function transformHashtag(text: string): string {
  return text
    .split(" ")
    .map((word) => (word ? `#${word}` : ""))
    .join(" ");
}

export function transformText(text: string, style: string): string {
  switch (style) {
    case "bold":
      return transformWithMapping(text, mathBold);
    case "italic":
      return transformWithMapping(text, mathItalic);
    case "boldItalic":
      return transformWithMapping(text, mathBoldItalic);
    case "serif":
      return transformSerif(text);
    case "sans":
      return transformWithMapping(text, mathSans);
    case "sansBold":
      return transformWithMapping(text, mathSansBold);
    case "sansItalic":
      return transformWithMapping(text, mathSansItalic);
    case "sansBoldItalic":
      return transformWithMapping(text, mathSansBoldItalic);
    case "monospace":
      return transformWithMapping(text, mathMonospace);
    case "fraktur":
      return transformWithMapping(text, fraktur);
    case "boldFraktur":
      return transformWithMapping(text, boldFraktur);
    case "script":
      return transformWithMapping(text, script);
    case "boldScript":
      return transformWithMapping(text, boldScript);
    case "smallCaps":
      return transformWithMapping(text, smallCaps);
    case "doubleStruck":
      return transformWithMapping(text, doubleStruck);
    case "squared":
      return transformWithMapping(text, squared);
    case "circled":
      return transformWithMapping(text, circled);
    case "bubble":
      return transformWithMapping(text, bubble);
    case "blackSquares":
      return transformWithMapping(text, blackSquares);
    case "negativeSquared":
      return transformWithMapping(text, blackSquares);
    case "negativeCircled":
      return transformWithMapping(text, bubble);
    case "outline":
      return transformWithMapping(text, outline);
    case "tiny":
      return transformWithMapping(text, tiny);
    case "superscript":
      return transformWithMapping(text, superscript);
    case "subscript":
      return transformWithMapping(text, subscript);
    case "spaced":
      return transformSpaced(text);
    case "upsideDown":
      return transformUpsideDown(text);
    case "strike":
      return transformStrike(text);
    case "underline":
      return transformUnderline(text);
    case "slash":
      return transformSlash(text);
    case "wave":
      return transformWave(text);
    case "zalgo":
      return transformZalgo(text);
    case "currency":
      return transformCurrency(text);
    case "regional":
      return transformWithMapping(text, regionalIndicator);
    case "parenthesized":
      return transformWithMapping(text, parenthesized);
    case "fullwidth":
      return transformWithMapping(text, fullwidth);
    case "dotted":
      return transformDotted(text);
    case "doubleUnderline":
      return transformDoubleUnderline(text);
    case "overline":
      return transformOverline(text);
    case "diaeresis":
      return transformDiaeresis(text);
    case "inverted":
      return transformInverted(text);
    case "braille":
      return transformWithMapping(text, braille);
    case "signature":
      // Custom Text.onl signature style - mix of script and small caps
      return text
        .split("")
        .map((char, index) => {
          if (index % 2 === 0) {
            return script[char] || char;
          } else {
            return smallCaps[char] || char;
          }
        })
        .join("");
    case "emojiLetters":
      return transformWithMapping(text, emojiLetters);
    case "emojiNumbers":
      return transformWithMapping(text, emojiNumbers);
    case "emojiMix":
      return transformEmojiMix(text);
    case "arabic":
      return transformWithMapping(text, arabicStyle);
    case "hiragana":
      return transformWithMapping(text, hiraganaStyle);
    case "chinese":
      return transformWithMapping(text, chineseStyle);
    case "stars":
      return transformStars(text);
    case "hearts":
      return transformHearts(text);
    case "arrows":
      return transformArrows(text);
    case "diamonds":
      return transformDiamonds(text);
    case "flowers":
      return transformFlowers(text);
    case "crowns":
      return transformCrowns(text);
    case "asciiBox":
      return transformAsciiBox(text);
    case "asciiStars":
      return transformAsciiStars(text);
    case "asciiBorder":
      return transformAsciiBorder(text);
    case "starBasic":
      return transformStarBasic(text);
    case "starDouble":
      return transformStarDouble(text);
    case "starOrnate":
      return transformStarOrnate(text);
    case "starCelestial":
      return transformStarCelestial(text);
    case "starElegant":
      return transformStarElegant(text);
    case "starDream":
      return transformStarDream(text);
    case "starClassic":
      return transformStarClassic(text);
    case "starMystic":
      return transformStarMystic(text);
    case "starGentle":
      return transformStarGentle(text);
    case "starReverse":
      return transformStarReverse(text);
    case "starSimple":
      return transformStarSimple(text);
    case "starLuxury":
      return transformStarLuxury(text);

    // Heart decorations
    case "heartBasic":
      return transformHeartBasic(text);
    case "heartDouble":
      return transformHeartDouble(text);
    case "heartWave":
      return transformHeartWave(text);
    case "heartPink":
      return transformHeartPink(text);
    case "heartRounded":
      return transformHeartRounded(text);
    case "heartPattern":
      return transformHeartPattern(text);
    case "heartMusic":
      return transformHeartMusic(text);
    case "heartRepeat":
      return transformHeartRepeat(text);
    case "heartSimple":
      return transformHeartSimple(text);
    case "heartFloral":
      return transformHeartFloral(text);
    case "heartElaborate":
      return transformHeartElaborate(text);
    case "heartCute":
      return transformHeartCute(text);

    // Decorative patterns
    case "decorativeStars":
      return transformDecorativeStars(text);
    case "musicalNotes":
      return transformMusicalNotes(text);
    case "blockBars":
      return transformBlockBars(text);
    case "progressiveBars":
      return transformProgressiveBars(text);
    case "shadedBlocks":
      return transformShadedBlocks(text);
    case "textPattern":
      return transformTextPattern(text);
    case "moonStars":
      return transformMoonStars(text);
    case "circleDots":
      return transformCircleDots(text);
    case "ornamental":
      return transformOrnamental(text);

    // Joined text styles
    case "waveJoined":
      return transformWaveJoined(text);
    case "blockJoined":
      return transformBlockJoined(text);
    case "heartJoined":
      return transformHeartJoined(text);
    case "arrowJoined":
      return transformArrowJoined(text);
    case "starJoined":
      return transformStarJoined(text);
    case "crossJoined":
      return transformCrossJoined(text);
    case "ringJoined":
      return transformRingJoined(text);
    case "complexJoined1":
      return transformComplexJoined1(text);
    case "complexJoined2":
      return transformComplexJoined2(text);

    // Emoticon styles
    case "bracketEmoticon":
      return transformBracketEmoticon(text);
    case "cuteEmoticon":
      return transformCuteEmoticon(text);
    case "happyFlower":
      return transformHappyFlower(text);
    case "shrugEmoticon":
      return transformShrugEmoticon(text);
    case "wideEyes":
      return transformWideEyes(text);
    case "heartEyes":
      return transformHeartEyes(text);
    case "heartCheeks":
      return transformHeartCheeks(text);
    case "subtleEmoticon":
      return transformSubtleEmoticon(text);
    case "nestedEmoticon":
      return transformNestedEmoticon(text);

    // Adorable styles
    case "adorableMusic":
      return transformAdorableMusic(text);
    case "adorableCandy":
      return transformAdorableCandy(text);
    case "adorableHeart":
      return transformAdorableHeart(text);
    case "adorableFlower":
      return transformAdorableFlower(text);
    case "adorableSymbol":
      return transformAdorableSymbol(text);
    case "adorableFleur":
      return transformAdorableFleur(text);
    case "adorableShamrock":
      return transformAdorableShamrock(text);
    case "adorableBrackets":
      return transformAdorableBrackets(text);
    case "adorablePetal":
      return transformAdorablePetal(text);

    // Wild styles
    case "wildCircles":
      return transformWildCircles(text);
    case "wildEmoji1":
      return transformWildEmoji1(text);
    case "wildEmoji2":
      return transformWildEmoji2(text);
    case "wildBorder":
      return transformWildBorder(text);
    case "wildFaces":
      return transformWildFaces(text);
    case "wildSpooky":
      return transformWildSpooky(text);
    case "wildCandy":
      return transformWildCandy(text);
    case "wildMusic":
      return transformWildMusic(text);
    case "wildAlien":
      return transformWildAlien(text);

    // Christmas styles
    case "christmasSanta":
      return transformChristmasSanta(text);
    case "christmasSnowman":
      return transformChristmasSnowman(text);
    case "christmasSnowflake":
      return transformChristmasSnowflake(text);
    case "christmasStocking":
      return transformChristmasStocking(text);
    case "christmasStars":
      return transformChristmasStars(text);
    case "christmasGifts":
      return transformChristmasGifts(text);

    // === NEW CASE TRANSFORMATIONS ===
    case "alternatingCase":
      return transformAlternatingCase(text);
    case "invertedAlternating":
      return transformInvertedAlternating(text);
    case "camelCase":
      return transformCamelCase(text);
    case "pascalCase":
      return transformPascalCase(text);
    case "snakeCase":
      return transformSnakeCase(text);
    case "kebabCase":
      return transformKebabCase(text);
    case "constantCase":
      return transformConstantCase(text);
    case "reverse":
      return transformReverse(text);
    case "reverseWords":
      return transformReverseWords(text);
    case "mirror":
      return transformMirror(text);
    case "leetSpeak":
      return transformLeetSpeak(text);
    case "leetAdvanced":
      return transformLeetAdvanced(text);
    case "mockingSpongebob":
      return transformMockingSpongebob(text);
    case "wideAesthetic":
      return transformWideAesthetic(text);
    case "vaporwave":
      return transformVaporwave(text);
    case "binary":
      return transformBinary(text);
    case "morse":
      return transformMorse(text);
    case "titleCase":
      return transformTitleCase(text);
    case "sentenceCase":
      return transformSentenceCase(text);
    case "toggleCase":
      return transformToggleCase(text);
    case "clapEmoji":
      return transformClapEmoji(text);
    case "fireBorder":
      return transformFireBorder(text);
    case "sparklesBorder":
      return transformSparklesBorder(text);

    // New transformations
    case "blockLetters":
      return transformBlockLetters(text);
    case "dotMatrix":
      return transformDotMatrix(text);
    case "gradientLight":
      return transformGradientLight(text);
    case "gradientHeavy":
      return transformGradientHeavy(text);
    case "rainbowCircles":
      return transformRainbowCircles(text);
    case "progressiveStars":
      return transformProgressiveStars(text);
    case "invisibleSpaces":
      return transformInvisibleSpaces(text);
    case "invisibleJoiner":
      return transformInvisibleJoiner(text);
    case "watermark":
      return transformWatermark(text);
    case "kaomojiHappy":
      return transformKaomojiHappy(text);
    case "kaomojiCat":
      return transformKaomojiCat(text);
    case "kaomojiStar":
      return transformKaomojiStar(text);
    case "kaomojiBear":
      return transformKaomojiBear(text);
    case "kaomojiFlip":
      return transformKaomojiFlip(text);
    case "kaomojiShrug":
      return transformKaomojiShrug(text);
    case "boxLight":
      return transformBoxLight(text);
    case "boxDouble":
      return transformBoxDouble(text);
    case "boxRound":
      return transformBoxRound(text);
    case "typewriter":
      return transformTypewriter(text);
    case "glitch":
      return transformGlitch(text);
    case "zalgoLight":
      return transformZalgoLight(text);
    case "bubbleWrap":
      return transformBubbleWrap(text);
    case "hashtag":
      return transformHashtag(text);

    default:
      return text;
  }
}

// Helper function to get available transformers
export function getAvailableTransformers(): string[] {
  return [
    "bold",
    "italic",
    "boldItalic",
    "sans",
    "sansBold",
    "sansItalic",
    "sansBoldItalic",
    "monospace",
    "fraktur",
    "boldFraktur",
    "script",
    "boldScript",
    "smallCaps",
    "doubleStruck",
    "squared",
    "circled",
    "blackSquares",
    "outline",
    "tiny",
    "superscript",
    "subscript",
    "spaced",
    "upsideDown",
    "strike",
    "underline",
    "slash",
    "wave",
    "zalgo",
    "parenthesized",
    "fullwidth",
    "dotted",
    "doubleUnderline",
    "overline",
    "diaeresis",
    "inverted",
    "braille",
    "signature",
    "emojiLetters",
    "emojiNumbers",
    "emojiMix",
    "arabic",
    "hiragana",
    "chinese",
    "stars",
    "hearts",
    "arrows",
    "diamonds",
    "flowers",
    "crowns",
    "asciiBox",
    "asciiStars",
    "asciiBorder",
    "starBasic",
    "starDouble",
    "starOrnate",
    "starCelestial",
    "starElegant",
    "starDream",
    "starClassic",
    "starMystic",
    "starGentle",
    "starReverse",
    "starSimple",
    "starLuxury",
    "heartBasic",
    "heartDouble",
    "heartWave",
    "heartPink",
    "heartRounded",
    "heartPattern",
    "heartMusic",
    "heartRepeat",
    "heartSimple",
    "heartFloral",
    "heartElaborate",
    "heartCute",
    "decorativeStars",
    "musicalNotes",
    "blockBars",
    "progressiveBars",
    "shadedBlocks",
    "textPattern",
    "moonStars",
    "circleDots",
    "ornamental",
    "waveJoined",
    "blockJoined",
    "heartJoined",
    "arrowJoined",
    "starJoined",
    "crossJoined",
    "ringJoined",
    "complexJoined1",
    "complexJoined2",
    "bracketEmoticon",
    "cuteEmoticon",
    "happyFlower",
    "shrugEmoticon",
    "wideEyes",
    "heartEyes",
    "heartCheeks",
    "subtleEmoticon",
    "nestedEmoticon",
    "adorableMusic",
    "adorableCandy",
    "adorableHeart",
    "adorableFlower",
    "adorableSymbol",
    "adorableFleur",
    "adorableShamrock",
    "adorableBrackets",
    "adorablePetal",
    "wildCircles",
    "wildEmoji1",
    "wildEmoji2",
    "wildBorder",
    "wildFaces",
    "wildSpooky",
    "wildCandy",
    "wildMusic",
    "wildAlien",
    "christmasSanta",
    "christmasSnowman",
    "christmasSnowflake",
    "christmasStocking",
    "christmasStars",
    "christmasGifts",
  ];
}
